import { encodePayload } from './utils';
const defaultOptions = {
    maxEvents: 10,
    intervalMs: 10 * 1000,
};
export class EventsCollector {
    constructor(options) {
        this.events = [];
        this.options = {
            ...defaultOptions,
            ...options,
        };
        this.start();
        this.listenBeforeUnload();
    }
    start() {
        this.intervalId = setInterval(() => {
            this.sendEvents();
        }, this.options.intervalMs);
    }
    sendEvents() {
        if (this.events.length > 0) {
            const data = this.events.join('\\n');
            this.sendBeacon(data);
        }
    }
    sendBeacon(data) {
        if ('sendBeacon' in navigator) {
            const success = navigator.sendBeacon(this.options.url, data);
            if (success) {
                this.clean();
            }
        }
        else {
            fetch(this.options.url, { method: 'POST', body: data });
            this.clean();
        }
    }
    listenBeforeUnload() {
        window.addEventListener('beforeunload', () => {
            this.sendEvents();
        });
    }
    clean() {
        this.events = [];
    }
    addEvent(payload) {
        const payloadStr = encodePayload(payload);
        this.events.push(payloadStr);
        if (this.events.length > this.options.maxEvents) {
            this.sendEvents();
        }
    }
    stop() {
        clearInterval(this.intervalId);
        this.sendEvents();
    }
}
